import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchWithdrawal = createAsyncThunk(
  "withdrawal/fetchWithdrawal",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/admin/withdrawals", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const approveWithdrawal = createAsyncThunk(
  "withdrawal/approveWithdrawal",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post(`/approve/withdrawal/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return response.data; //
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const approveWithdrawalManually = createAsyncThunk(
  "withdrawal/approveWithdrawalManually",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post(
        `/approve/withdrawal/manually/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data; //
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const deleteWithdrawal = createAsyncThunk(
  "withdrawal/deleteWithdrawal",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.delete(`/delete-withdrawal/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const withdrawalSlice = createSlice({
  name: "withdrawal",
  initialState: {
    withdrawals: [],
    status: "idle",
    error: null,
    deleteWithdrawalStatus: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWithdrawal.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchWithdrawal.fulfilled, (state, action) => {
        state.status = "success";
        state.withdrawals = action.payload.data;
      })
      .addCase(fetchWithdrawal.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(approveWithdrawal.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(approveWithdrawal.fulfilled, (state) => {
        state.status = "idle";
        state.error = null;
      })
      .addCase(approveWithdrawal.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload;
      })
      .addCase(approveWithdrawalManually.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(approveWithdrawalManually.fulfilled, (state) => {
        state.status = "idle";
        state.error = null;
      })
      .addCase(approveWithdrawalManually.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload;
      })
        .addCase(deleteWithdrawal.pending, (state) => {
        state.deleteWithdrawalStatus = "loading";
        state.error = null;
      })
      .addCase(deleteWithdrawal.fulfilled, (state) => {
        state.deleteWithdrawalStatus = "idle";
        state.error = null;
      })
      .addCase(deleteWithdrawal.rejected, (state, action) => {
        state.deleteWithdrawalStatus = "idle";
        state.error = action.payload;
      });
  },
});

export default withdrawalSlice.reducer;
